<div class="btn-group" ngbDropdown>
    <button class="btn btn-outline-secondary" ngbDropdownToggle>
        {{ hasCustom && selectedMonths.length ? 'Custom' : (selectedDays ? (addYears < 0 ? 'Last ' : 'Next ') + selectedDays + ' days' : 'Not selected') }}
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
        <div class="p-3">
            <div *ngFor="let days of [7, 14, 30]">
                <label class="kt-checkbox kt-checkbox--bold" [class.kt-checkbox--brand]="selectedDays === days">
                    <input type="checkbox" [name]="'status-' + id" (click)="selectDays($event, days)"
                        [checked]="selectedDays === days">{{addYears < 0 ? 'Last' : 'Next'}} {{days}} days<span></span>
                </label>
            </div>
            <hr>
            <div>
                <label class="kt-checkbox kt-checkbox--bold" [class.kt-checkbox--brand]="hasCustom">
                    <input type="checkbox" [name]="'status-' + id" (click)="selectCustom($event)"
                        [checked]="hasCustom">Custom<span></span>
                </label>
                <span *ngIf="hasCustom && selectedMonths.length" class="right kt-font-brand cursor-pointer"
                    (click)="selectedMonths = []">Clear Selections</span>
            </div>
            <div *ngIf="hasCustom">
                <div class="d-flex bold mb-2 cursor-pointer">
                    <button class="btn btn-sm btn-outline-secondary" (click)="viewYear(selectedYear - 1)"
                        [disabled]="!visibleYears.includes(selectedYear - 1)"><</button>
                    <div class="d-flex w-100">
                        <div *ngFor="let year of visibleYears" class="year text-center w-100"
                            [class.kt-font-brand]="selectedYear === year"
                            (click)="viewYear(year)">{{'20' + year}}</div>
                    </div>
                    <button class="btn btn-sm btn-outline-secondary" (click)="viewYear(selectedYear + 1)"
                        [disabled]="!visibleYears.includes(selectedYear + 1)">></button>
                </div>
                <div class="d-flex" *ngFor="let i of [0, 1, 2]" [class.mt-2]="i > 0">
                    <div class="w-25" *ngFor="let m of [0, 1, 2, 3]" [class.pl-2]="m > 0">
                        <button [ngClass]="getMonthIndex((i * 4) + m, selectedYear) >= 0 ? 'btn-brand' : 'btn-outline-secondary'"
                            (click)="selectMonth((i * 4) + m, selectedYear)" class="btn btn-sm btn-block"
                            [disabled]="currentYear === selectedYear && ((addYears > 0 && currentMonth > (i*4) + m) ||
                                (addYears < 0 && currentMonth < (i*4) + m)) ? true : null">
                            {{months[(i * 4) + m]}}<br>{{selectedYear}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>